import { tracked } from '@glimmer/tracking';

import { TrackingEvent } from 'webapp/enums/tracking';

import FilterSortAvailableSource from 'webapp/models-custom/filter-sort/available-source';

export default class FilterSortAvailableSourceInWizard extends FilterSortAvailableSource {
	@tracked override sortProp = ''; // because we are sorting allItems by isRecommended and popularity in sortedAvailableSources at /controllers/wizard/source.js

	override saveFilterInUrlHash = false;

	override typedFilterEventName = TrackingEvent.SOURCE_SEARCH;
}
